import { Title } from '@gerdau/hefesto/Title';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ETowerOption } from '../../../../../store/ducks/contracts-and-constructions/types';
import { IFabricationContract } from '../../../../../store/ducks/fabrication-contracts/types';
import { IContractCustomer } from '../../../../../store/ducks/fabrication-contracts/types';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import {
  uppercaseOnlyFirstLetter,
  cnpjMask
} from '../../../../../utils/formatStrings';
import { weekDayMap } from '../../../ConstructionRegistration/constructionRegistrationFieldsValidations';
import { ContentBlock, ContentSide, ExpandedRowContainer } from './styles';

interface IExpandedContractRowContentProps {
  customerContract: IFabricationContract;
}

const ExpandedContractRowContent: React.FC<
  IExpandedContractRowContentProps
> = ({ customerContract }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: 'LG:ContratosEObras:SelecaoDoEmissor',
        itemName: 'expandable_card:ver_detalhes',
        itemDescription: 'contratoEObras_selecaoDoEmissor_verDetalhes',
        event: 'click'
      })
    );
  }, []);

  const getShipToAddress = (shipTo: IContractCustomer) => {
    // Rua Nome da rua 123 - Nome da Cidade, UF - 00000-0004
    return `${uppercaseOnlyFirstLetter(
      shipTo.address || ''
    )} - ${uppercaseOnlyFirstLetter(shipTo.city || '')}, ${shipTo.state} - ${
      shipTo.zipCode
    }`;
  };

  return (
    <ExpandedRowContainer>
      <ContentSide>
        <ContentBlock>
          <Title level={3}>Dados da obra</Title>

          <div className="content">
            <div>
              <span className="label">CNPJ da matriz</span>
              <span>{cnpjMask(customerContract.soldTo.taxNumber || '')}</span>
            </div>
            <div>
              <span className="label">CNPJ da obra (SPE)</span>
              <span>{cnpjMask(customerContract.shipTo.taxNumber || '')}</span>
            </div>
          </div>
        </ContentBlock>
        <ContentBlock>
          <div className="content">
            <div>
              <span className="label">Inscrição estadual da obra</span>
              <span>{customerContract.shipTo.taxState}</span>
            </div>
          </div>
        </ContentBlock>

        <ContentBlock>
          <Title level={3}>Condições de entrega</Title>

          <div className="content firstcolumn">
            <div className="dayandtime">
              <span className="label">Horários de recebimento</span>
              {customerContract.logistic?.schedules.map((dayAndTime) => (
                <div key={dayAndTime.day}>
                  <span>{weekDayMap.get(dayAndTime.day)}</span>
                  <span>
                    {`das ${dayAndTime.startTime || ' - '} às ${
                      dayAndTime.endTime || ' - '
                    }`}
                  </span>
                </div>
              ))}
              {customerContract.logistic?.schedules.length === 0 && <>-</>}
            </div>
            <div>
              <span className="label">Tipo de veículo</span>
              {customerContract.logistic?.vehicleType.map((vehicle) => (
                <span key={vehicle}>{vehicle}</span>
              ))}

              {customerContract.logistic?.vehicleType.length === 0 && <>-</>}
            </div>
          </div>
        </ContentBlock>

        <ContentBlock>
          <div className="content">
            <div>
              <span className="label">Tipo de descarga</span>
              <span>{customerContract.logistic?.dischargeType}</span>
            </div>
          </div>
        </ContentBlock>

        <ContentBlock>
          <div className="content">
            <div>
              <Title level={3}>Observações sobre a descarga</Title>
              <span>
                {customerContract.logistic?.dischargeObservation || ' - '}
              </span>
            </div>
          </div>
        </ContentBlock>
      </ContentSide>

      <ContentSide>
        <ContentBlock>
          <Title level={3}>Endereço da obra</Title>

          <div className="content">
            <div>
              <span className="label">Endereço</span>
              <span>{getShipToAddress(customerContract.shipTo)}</span>
            </div>
          </div>
        </ContentBlock>

        <ContentBlock>
          <div className="content">
            <div>
              <span className="label">Torres / Blocos</span>
              <span>
                {customerContract?.logistic?.towerOption === ETowerOption.UNIQUE
                  ? 'Torre ou bloco único'
                  : customerContract?.logistic?.towers?.join(', ') || ' - '}
              </span>
            </div>
          </div>
        </ContentBlock>

        <ContentBlock>
          <Title level={3}>Responsáveis pela obra</Title>

          <div className="content responsibles">
            {customerContract.logistic?.responsiblesOfConstruction.map(
              (responsible, idx) => (
                <div key={idx}>
                  <span className="label">{responsible.name}</span>
                  <span>{responsible.jobTitle}</span>
                  <span>{responsible.email}</span>
                  <span>{responsible.phoneNumber}</span>
                </div>
              )
            )}

            {customerContract.logistic?.responsiblesOfConstruction.length ===
              0 && <>-</>}
          </div>
        </ContentBlock>
      </ContentSide>
    </ExpandedRowContainer>
  );
};

export default ExpandedContractRowContent;
